import(/* webpackMode: "eager" */ "/opt/build/repo/app/adults/page.tsx")